/** Delay to show/hide the popover on the media selector for an item when mouse hover (milliseconds) */
export const MEDIA_SELECTOR_SHOW_POPOVER_DELAY = 800;
export const MEDIA_SELECTOR_HIDE_POPOVER_DELAY = 0;

export const MEDIA_SELECTOR_POPOVER_IMG_SIZE = { height: 500, width: 620 };
